import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function LongTestimonials() {
  const testimonials = [{
    quote: 'Compré un domingo a la noche. El lunes entré a la sesión con el plan exacto de qué hacer. El Tomo 1 es exactamente lo que necesitaba para organizar toda mi práctica. Nunca más improviso.',
    name: 'Valentina M.',
    role: 'Psicóloga especialista en maternidad',
    location: 'Buenos Aires',
    initial: 'V',
    color: 'bg-terracotta-100 text-terracotta-700'
  }, {
    quote: 'El Tomo 2, el del fichero clínico, me cambió todo. El primer mes, pacientes que llevaban meses estancadas mejoraron visiblemente. El fichero de herramientas me da la tranquilidad que antes no tenía.',
    name: 'Florencia R.',
    role: 'Obstétrica en Centro de Salud',
    location: 'Rosario',
    initial: 'F',
    color: 'bg-gold-100 text-gold-700'
  }, {
    quote: 'El sistema de guiones es único en el mercado. 80 herramientas listas con objetivos y adaptaciones por perfil. Antes tardaba horas armando una sesión. Ahora abro el PDF y en 5 minutos tengo todo listo.',
    name: 'Daniela F.',
    role: 'Puericultora y acompañante de postparto',
    location: 'Córdoba',
    initial: 'D',
    color: 'bg-sage-100 text-sage-700'
  }, {
    quote: 'Las planillas del Tomo 3 eliminaron mi inseguridad al evaluar. Ahora sé exactamente cómo está cada paciente y puedo mostrárselo a su médico y a la institución. Mis sesiones tienen otro nivel.',
    name: 'Luciana P.',
    role: 'Enfermera obstétrica en práctica privada',
    location: 'Tucumán',
    initial: 'L',
    color: 'bg-navy-100 text-navy-700'
  }, {
    quote: 'La tasa de abandono de mis pacientes bajó muchísimo. Sin cambiar lo que hago. Solo aplicando el sistema de seguimiento y la variedad de los 6 tomos. Las pacientes ahora quieren volver porque sienten que progresan.',
    name: 'Marcela G.',
    role: 'Acompañante de postparto online y presencial',
    location: 'Mendoza',
    initial: 'M',
    color: 'bg-terracotta-100 text-terracotta-700'
  }, {
    quote: 'El Tomo 6 de DPP me salvó de seguir dependiendo de la intuición en las situaciones más difíciles. Ahora tengo un protocolo claro. Actúo con seguridad cuando antes entraba en pánico.',
    name: 'Laura V.',
    role: 'Psicóloga perinatal en consultorio propio',
    location: 'Santa Fe',
    initial: 'L',
    color: 'bg-gold-100 text-gold-700'
  }, {
    quote: 'El Pack Plus me cambió la cabeza. Nunca había dimensionado el potencial de profesionalizar mi imagen y tener mi propia consulta organizada. Ahora trabajo con una seguridad que antes no tenía y cobro lo que realmente merezco.',
    name: 'Ana R.',
    role: 'Obstétrica en práctica independiente',
    location: 'Salta',
    initial: 'A',
    color: 'bg-sage-100 text-sage-700'
  }];
  return <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-cream overflow-hidden" data-id="element-136">
      <div className="max-w-7xl mx-auto" data-id="element-137">
        <div className="text-center mb-8 md:mb-16" data-id="element-138">
          <h2 className="text-2xl md:text-5xl font-bold text-navy mb-2 md:mb-4" data-id="element-139">
            Lo que dicen las profesionales que ya lo usan:
          </h2>
          <p className="text-base md:text-xl text-navy/70 font-serif italic" data-id="element-140">
            +300 profesionales de postparto de todo el país ya tienen su Kit
            Profesional Postparto™
          </p>
        </div>

        <div className="flex overflow-x-auto pb-6 -mx-4 px-4 md:columns-2 lg:columns-3 md:overflow-visible md:pb-0 md:mx-0 md:px-0 gap-4 md:gap-6 md:space-y-6 snap-x snap-mandatory hide-scrollbar" data-id="element-141">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.1
        }} whileHover={{
          y: -2
        }} className="min-w-[85vw] md:min-w-0 snap-center bg-white rounded-2xl md:rounded-3xl p-5 md:p-8 shadow-soft border border-navy/5 break-inside-avoid relative mb-0 md:mb-6" data-id="element-142">
              <Quote className="w-6 h-6 md:w-8 md:h-8 text-navy/5 absolute top-4 right-4 md:top-6 md:right-6" data-id="element-143" />

              <p className="text-sm md:text-base text-navy/80 italic mb-4 md:mb-6 relative z-10 leading-relaxed" data-id="element-144">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-3 md:gap-4 pt-4 md:pt-6 border-t border-navy/5" data-id="element-145">
                <div className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-serif text-base md:text-lg font-bold flex-shrink-0 ${t.color}`} data-id="element-146">
                  {t.initial}
                </div>
                <div data-id="element-147">
                  <h4 className="font-bold text-navy text-xs md:text-sm" data-id="element-148">
                    {t.name}
                  </h4>
                  <p className="text-[10px] md:text-xs text-navy/60" data-id="element-149">
                    {t.role}
                  </p>
                  <p className="text-[10px] md:text-xs text-navy/40 mt-0.5 flex items-center gap-1" data-id="element-150">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
      <style dangerouslySetInnerHTML={{
      __html: `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `
    }} data-id="element-151" />
    </section>;
}